export default __webpack_public_path__ + "static/media/Eina02-SemiBold.c5f9b8e3.ttf";